import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import DateHelperClass from '@/helpers/DateHelper' 

    export class AppointmentModel extends Model  {
      key: string;
      customer_key: string;
      dossier_key: string;
      task_key: string;
      priority: number = 0;
      cperson:any = {};
      name:string = "";
      description: string = "";
      _start_at: number = DateHelperClass.getCurrent("ms") as number;
      timeindication: string;
      workhours:number;
      type:number = 3;
      state:number = 5;
      location:any = {}
      
        constructor(data = null) {
            super();
            
            if(data) {
                this.createModel(data);
            }
            
        }
     
        public createModel(data, collection:any = {}) {
            
            if(data && data?.data) {
                if(data.data?.cperson) {
                    this.cperson = data.data.cperson;
                }
                if(data.data?.location) {
                    this.location = data.data.location;
                }
                delete data.data;
            }
            
            return super.createModel(data, collection);
        }
        
        get start_at() {
            if(!this._start_at) {
                let tmpVal: number = DateHelperClass.getCurrent("ms") as number;
                this._start_at = tmpVal;
            }
            return this._start_at;
        }   
        set start_at(val) {
            this._start_at = val;
        }
        
        getStartAt(format) {
            let startAt = this._start_at;
            console.debug( DateHelperClass.getCurrent("") );
            DateHelperClass.getCurrent("DDMMYYYY");
            return DateHelperClass.getCurrent("ms");
        }
    }